import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import { makePossessive } from '@src/utilities/format';
import ReferralForm from '../../forms/ReferralForm';
import './Referral.scss';

type Props = {
  employerName?: string;
  title: string;
};

const Referral: React.FC<Props> = ({ employerName, title }) => {
  const subHeading =
    employerName === 'Walmart'
      ? 'Your Guild benefit can help family members earn a high school diploma. Eligible family members of Walmart employees can get funding for applicable High School Completion Programs. Funding is not available for other programs.'
      : `Spread the word about ${makePossessive(
          employerName || 'your employer'
        )} education benefits! Enter a colleague's email to help them learn how to go back to school.`;

  return (
    <div>
      <Typography variant='h3'>{title}</Typography>
      <div className='subHeading'>
        <Typography variant='body1'>{subHeading}</Typography>
        {employerName === 'Walmart' && (
          <Typography variant='body1' className='subText'>
            Enter their email below and we&apos;ll send them a message to get started.
          </Typography>
        )}
      </div>
      <ReferralForm
        label={employerName === 'Walmart' ? "Family member's email" : "Colleague's email"}
      />
    </div>
  );
};

export default Referral;
